module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipoint-topup ipoint-payment myaddress"
  }, [_c('label', {
    staticClass: "profile-radio pay_type",
    on: {
      "click": function($event) {
        _vm.checkRadio(1, $event)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.tag == 1
    },
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('label', {
    staticClass: "profile-radio pay_type",
    on: {
      "click": function($event) {
        _vm.checkRadio(3, $event)
      }
    }
  }, [_c('span', {
    staticClass: "pro-radio",
    class: {
      'pro-radio-checked': _vm.tag == 3
    },
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('span', {
    staticClass: "pro-radio-inner"
  }), _vm._v(" "), _c('input', {
    staticClass: "pro-radio-input",
    attrs: {
      "type": "radio"
    }
  })]), _vm._v(" "), _vm._m(1, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-group payment-group-paypal"
  }, [_c('button', {
    staticClass: "payment-icon",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/profile/visa.jpg"),
      "alt": "",
      "width": "88"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-group payment-group-paypal"
  }, [_c('button', {
    staticClass: "payment-icon",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/profile/paypal.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad11e4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyDetails/Common/Mypayment.vue
// module id = 789
// module chunks = 0